<template>
    <div>
         <div class="row">
             <div class="col-md-12 text-right mb-4 ">
                 <a href="#" @click="addContact" class="btn btn-primary">
                     Add
                 </a>
             </div>
         </div>

        <div class="card border-0">
             <div class="card-header">
                 <span>Emergency Contacts</span>
             </div>
             <div class="card-body gray-bg">
                 <div class="justify-content-center sb-personal-health-record">
                     <div class="col-md-12">
                         <br/>

                         <div :class='{"py-3 px-4":true, "bg-light": index % 2}' v-for="(contact, index) in contacts">

                             <div class="row">
                                 <div class="col-md-9 border-bottom">
                                     <p class="sb-personal-p">
                                         <span>Contact Name (First Name Last Name)</span>
                                         <br/>
                                         {{contact.con_fname}} {{contact.con_lname}}
                                     </p>
                                 </div>
                                 <div class="col-md-3 text-right sb-list-sitem border-bottom">
                                     <a href="#" @click="show(contact)" :aria-label="'Edit contact details for ' + contact.con_fname + ' ' + contact.con_lname">
                                         Edit
                                     </a>
                                 </div>
                             </div>
                             <div class="row">
                                 <div class="col-md-6 border-bottom border-right">
                                     <p class="sb-personal-p">
                                         <span>Relationship</span>
                                         <br/>
                                         {{contact.con_relationship}}
                                     </p>
                                 </div>
                                 <div :class="index % 2 === 0?'col-md-6 border-bottom':'col-md-6 border-bottom border-right'" v-for="(phone, index) in contact.phones">
                                     <p class="sb-personal-p">
                                         <span>{{phone_types[phone.type]}} Phone Number</span>
                                         <br/>
                                         {{phone.phone}}
                                     </p>
                                 </div>
                                 <div class="col-md-6 border-bottom" v-if="contact.con_phone">
                                     <p class="sb-personal-p">
                                         <span>Phone Number</span>
                                         <br/>
                                         {{contact.con_phone}}
                                     </p>
                                 </div>

                             </div>
                             <br/>
                         </div>
                     </div>
                 </div>
             </div>
         </div>



     <!-- Modal -->
     <div v-if="showModal">
         <transition name="modal">
             <div class="modal-mask">
                 <div class="modal-wrapper">
                     <div class="modal-dialog modal-lg" role="document">
                         <div class="modal-content">
                             <div class="modal-header">
                                 <h5 class="modal-title"><span v-if="update">Edit </span><span v-else>Add </span>Contact</h5>
                                 <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                     <span aria-hidden="true" @click="cancelContact()">&times;</span>
                                 </button>
                             </div>
                             <div class="modal-body" id="contact-form">
                                 <div class="form-group row">
                                     <label for="con_fname" class="col-sm-3 col-form-label">Name</label>
                                     <div class="col-sm-9">
                                         <input type="text" id="con_fname" autocomplete="off" name="con_fname" v-model="contact.con_fname" class="form-control">
                                     </div>
                                 </div>
                                 <div v-if="false" class="form-group row">
                                     <label for="con_lname" class="col-sm-4 col-form-label">Last Name</label>
                                     <div class="col-sm-8">
                                         <input type="text" id="con_lname" autocomplete="off" name="con_lname" v-model="contact.con_lname" class="form-control">
                                     </div>
                                 </div>
                                 <div class="form-group row">
                                     <label for="con_relationship" class="col-sm-3 col-form-label">Relationship</label>
                                     <div class="col-sm-9">
                                         <input type="text" id="con_relationship" autocomplete="off" name="con_relationship" v-model="contact.con_relationship" class="form-control">
                                     </div>
                                 </div>
                                 <div class="form-group row" v-for="(phone,index) in contact.phones">
                                     <label for="con_phone" class="col-sm-3 col-form-label" @input="acceptNumber">Phone</label>
                                     <div class="col-sm-3">
                                         <select
                                             v-model="contact.phones[index]['type']"
                                             name="phone_type"
                                             :aria-label="'Phone type for contact ' + index"
                                             class="form-control"
                                         >
                                             <option v-for="(value, key) in phone_types" :value="key">{{value}}</option>
                                         </select>
                                     </div>
                                     <div class="col-sm-4">
                                         <input
                                             v-model="contact.phones[index]['phone']"
                                             @input="acceptNumber(index)"
                                             :aria-label="'Phone number for contact ' + index"
                                             type="text"
                                             id="con_phone"
                                             autocomplete="off"
                                             name="con_phone"
                                             class="form-control"
                                         >
                                     </div>
                                     <div class="col-sm-2 text-right">
                                         <button
                                             @click="removeNumber(index)"
                                             :aria-label="'Remove phone number for contact ' + index"
                                             class="btn btn-danger"
                                             type="button"
                                         >
                                             <span aria-hidden="true">×</span>
                                         </button>
                                     </div>
                                 </div>
                                 <div class="form-group row">
                                     <div class="col-sm-12">
                                         <button class="btn btn-secondary btn-block" type="button" @click="addNumber">Add Phone</button>
                                     </div>
                                 </div>

                             </div>
                             <div class="modal-footer">
                                 <button type="button" class="btn btn-secondary" @click="cancelContact()">Cancel</button>
                                 <button v-if="update" type="button" class="btn btn-danger" @click="deleteContact">Delete</button>
                                 <button v-if="!update" type="button" class="btn btn-primary" @click="saveContact">Add</button>
                                 <button v-if="update" type="button" class="btn btn-primary" @click="updateContact">Save</button>
                             </div>
                         </div>
                     </div>
                 </div>
             </div>
         </transition>
     </div>
    </div>

</template>

<script>
    export default {
        props:['supplements'],
        mounted() {
            this.listContacts();
        },
        data(){
            return {
                route: '/api/emergency_contact',
                update: false,
                showModal: false,
                phone_types:{
                  'home':'Home',
                  'work':'Work',
                  'mobile1':'Mobile 1',
                  'mobile2':'Mobile 2'
                },
                contact:{
                    con_id:'',
                    con_fname:'',
                    con_lname:'',
                    phones:[],
                    con_relationship:''
                },
                contacts:[]
            }
        },
        methods:{
            removeNumber(index){
                this.contact.phones.splice(index,1)
            },
            addNumber(){
                this.contact.phones.push({'phone':'','type':'home'})
            },
            acceptNumber(index) {
                var x = this.contact.phones[index]['phone'].replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                this.contact.phones[index]['phone'] = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
            },
            addContact(){
                this.showModal=true;
                this.update=false
                this.contact={
                    con_id:'',
                    con_fname:'',
                    con_lname:'',
                    phones:[{'phone':'','type':'home'}],
                    con_relationship:''
                };
            },
            saveContact(){

                this.$http.post(this.route, this.contact)
                    .then(function(response) {
                        this.listContacts();
                        this.showModal=false;
                    }, (response) => {
                        this._handleErrors(response.data, '#contact-form')
                    })
            },
            listContacts(){
                this.$http.get(this.route)
                    .then(function(response) {
                        this.contacts=response.data;
                    }, (response) => {
                        this._handleErrors(response.data, '#contact-form')
                    })
            },
            show(contact){
                this.showModal=true;
                this.update=true
                this.contact=contact;
            },
            updateContact(){
                this.$http.put(this.route, this.contact)
                    .then(function(response) {
                        this.listContacts();
                        if(response.bodyText=="1"){
                            this.$notify({
                                type: 'success',
                                title: 'Success',
                                text: 'Contact was Updated!'
                            });
                        }else{
                            this.$notify({
                                type: 'error',
                                title: 'Success',
                                text: response.bodyText
                            });
                        }
                        this.showModal=false;
                    }, (response) => {
                        this._handleErrors(response.data, '#contact-form')
                    })
            },
            deleteContact(){
                this.$http.delete(this.route+'/'+this.contact.con_id, this.contact)
                    .then(function(response) {
                        this.listContacts();
                        if(response.bodyText=="1"){
                            this.$notify({
                                type: 'success',
                                title: 'Success',
                                text: 'Contact was deleted!'
                            });
                        }else{
                            this.$notify({
                                type: 'error',
                                title: 'Success',
                                text: response.bodyText
                            });
                        }
                        this.showModal=false;
                    }, (response) => {
                        this._handleErrors(response.data, '#contact-form')
                    })
            },
            _handleErrors: function(items, selector)
            {
                $('.has-error').removeClass('has-error')
                $('.help-block').remove()

                for (var error in items['errors']) {
                    if (items['errors'].hasOwnProperty(error)) {
                        var text = error;
                        var parts = text.split('.');
                        var name = parts.pop();
                        var el = $(selector + ' [name="'+name+'"]')
                        el.closest('.form-group').addClass('has-error')
                        $( '<p class="help-block">'+(items['errors'][error].join(', '))+'</p>' ).insertAfter(selector + ' [name="'+name+'"]');
                    }
                }
            },
            cancelContact(){
                this.listContacts();
                this.showModal = false;
            },
        }

    }
</script>
